import { useContext } from "react";

import {
    StepOne, 
    StepTwo, 
    StepThree, 
    StepFour
} from "../Steps";

import { StepOneFormProvider } from "../../shared/contexts";
import { QuotationInfoContext } from "../../shared/contexts/QuotationInfo";

import { StepTwoFormProvider } from "../Steps/StepTwo/contexts/StepTwoForm";
import { StepThreeFormProvider } from "../Steps/StepThree/contexts/StepThreeForm";
import { StepFourFormProvider } from "../Steps/StepFour/contexts/StepFourForm";
import { WizardDataFormProvider } from "./contexts/WizardDataForm/WizardDataFormProvider";

import { QuotationStep } from "../../shared/interfaces";
import { LoadSavedQuotation } from "../components/LoadSavedQuotation";

export const WizardLifeObligatory = () => {
    const { currentStep, loadingSavedQuotation } = useContext(QuotationInfoContext);

    const getStepComponent = () => {
        switch (currentStep) {
            case QuotationStep.ONE:
                return <StepOne />;
            case QuotationStep.TWO:
                return <StepTwo />;
            case QuotationStep.THREE:
                return <StepThree />;
            case QuotationStep.FOUR:
                return <StepFour />;
            default:
                break;
        }
    };

    return (
        <StepOneFormProvider>
            <WizardDataFormProvider>
                <StepTwoFormProvider>
                    <StepThreeFormProvider>
                        <StepFourFormProvider>
                        {
                            loadingSavedQuotation ? <LoadSavedQuotation/> : getStepComponent() 
                        }
                        </StepFourFormProvider>
                    </StepThreeFormProvider>
                </StepTwoFormProvider>
            </WizardDataFormProvider>
        </StepOneFormProvider>
    )
}
